// @flow 
import { APP_ESSENTIAL_FETCH } from "./actionTypes";

import type { essentialFetchActionParamsType } from '../types';

export default (payload: essentialFetchActionParamsType) => ({
  type: APP_ESSENTIAL_FETCH,
  payload,
});
